import { FC } from 'react'
import Accordion from '../../../components/ui/Accordion'

type StepAccordionProps = {
  data?: { stepNumber: number; title: string; content: string }
}

const StepAccordion: FC<StepAccordionProps> = ({ data }) => {
  return (
    <li>
      <Accordion
        headerComponent={
          <section className="flex flex-row items-center flex-wrap gap-4">
            <div className="w-[30px] h-[30px] bg-accent rounded-full flex justify-center items-center">
              <p className="font-bold text-sm leading-none">{data?.stepNumber}</p>
            </div>
            <div className="text-xl md:text-2xl leading-[100%] break-words text-left hyphens-auto">{data?.title}</div>
          </section>
        }
        bodyComponent={<p className="text-lg leading-6 font-light pb-8">{data?.content}</p>}
        containerClassName={{
          collapsed: 'w-full transition'
        }}
        headerClassName={{ collapsed: 'pb-8' }}
      />
    </li>
  )
}
export default StepAccordion
